export const SET_BESPOKE = 'SET_BESPOKE'
export const RESET_BESPOKE = 'RESET_BESPOKE'
